import { render, staticRenderFns } from "./relatedCard.vue?vue&type=template&id=665e2e1a&"
import script from "./relatedCard.vue?vue&type=script&lang=js&"
export * from "./relatedCard.vue?vue&type=script&lang=js&"
import style0 from "./relatedCard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports